import {createContext, useContext, useEffect, useState} from "react";
import Cookies from "js-cookie";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [loggedIn, setLoggedIn] = useState(false);

    useEffect(() => {
        const token = Cookies.get("token");

        if (!!token) {
            setLoggedIn(true);
        }
    }, []);


    const login = (token, role) => {
        Cookies.set('token', token, { expires: 40, secure: true });
        Cookies.set('role', role, { expires: 40, secure: true });
        setLoggedIn(true);
    };

    const logout = () => {
        Cookies.remove("token");
        Cookies.remove('role');
        setLoggedIn(false);
    };

    const isLoggedIn = () => {
        const token = Cookies.get("token")
        return !!token;
    }

    const isAdmin = () => {
        const role = Cookies.get("role")
        return !!(role && role.toLowerCase() === "admin");
    }

    return (
        <AuthContext.Provider value={{loggedIn, login, logout, isAdmin, isLoggedIn}}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
